export default "__VITE_ASSET__n0bKVyC7__"